module.exports = __webpack_public_path__ + "static/coding_interactions_keyboard_3_dont-3c97925c24553302a6c8fdd1bb7bb0dd.png";